module.exports = __webpack_public_path__ + "img/23.222e574f.jpeg";